<script setup>
import {computed, ref, useAttrs} from "vue";
import {usePortalContentAndDesignStore} from "../../../stores/partners/portalContentAndDesignStore";
import AddImageButton from "../Pub/components/AddImageButton.vue";
import EditToggleButton from "../Pub/components/EditToggleButton.vue";

const portalContentAndDesignStore = usePortalContentAndDesignStore();

const props = defineProps({
    imagePath: {
        type: String,
        required: true,
    },
    imgClass: {
        type: String,
        default: '',
    },
    imgName: {
        type: String,
        required: true
    },
    title: {
        type: String,
        default: 'Image upload'
    },
    imageUploadUrl: {
        type: String,
        default: null
    },
    imageDeleteUrl: {
        type: String,
        default: null
    },
});

const isEditing = ref(false);
const hoverActive = ref(false);

const attrs = useAttrs()

const emit = defineEmits(['update:imagePath']);

const imgSrc = computed({
    get: () => props.imagePath,
    set: (value) => emit('update:imagePath', value)
});

const shouldShowAddImageButton = computed(() => {
    return portalContentAndDesignStore.liveDesignerEnabled
        && !isEditing.value
        && !imgSrc
        && props.showAddImageButton;
});

const toggleEdit = () => {
    isEditing.value = !isEditing.value
    if (!isEditing.value) {
        hoverActive.value = false
    }
}
</script>

<template>
<add-image-button
    v-if="shouldShowAddImageButton"
    @click="isEditing = true"
/>
<div
    v-if="imgSrc || isEditing"
    class="relative"
    @mouseenter="hoverActive = true"
    @mouseleave="hoverActive = false"
>
    <edit-toggle-button
        v-show="portalContentAndDesignStore.liveDesignerEnabled && (isEditing || hoverActive)"
        :is-editing="isEditing"
        @toggle="toggleEdit"
        class="transition-opacity duration-200"
    />

    <img v-if="!isEditing"
        :src="imgSrc"
        v-bind="attrs"
        :class="imgClass"
        alt=""
    />

    <file-upload
        v-else-if="isEditing"
        v-model:src="imgSrc"
        no_src="/images/upload-image.png"
        accept="image/*"
        :title="title"
        :name="imgName"
        :upload_url="imageUploadUrl"
        :delete_url="imageDeleteUrl"
    ></file-upload>
</div>
</template>
